import { useContentBundle } from '@/hooks/useContentBundle'
import { useAppStore } from '@/store/appStore'
import { SplashScreen } from '@/components/auth/SplashScreen'

export function ContentBundleLoadingOverlay() {
  // isLoading (not isFetching) — only true when there is NO cached data at all.
  // Background re-fetches (stale timer, reconnect, window focus) keep the existing
  // data in the cache so isLoading stays false and the overlay stays hidden.
  const { isLoading } = useContentBundle()
  const isBundleRefreshing = useAppStore(s => s.isBundleRefreshing)
  if (!isLoading && !isBundleRefreshing) return null
  return <SplashScreen />
}
